// /* "Barrel" of Http Interceptors */
import { HTTP_INTERCEPTORS, HttpBackend } from '@angular/common/http';
import { Injector } from '@angular/core';
import { AuthHttpInterceptor } from '@auth0/auth0-angular';
import { BrandingService } from 'app/core/services/branding.service';
import { RefreshTokenInterceptor } from './refresh-token.interceptor';
import { RequestResponseInterceptor } from './request-response.interceptor';
import { UnauthenticatedRouteInterceptor } from './unauthenticated-route.interceptor';

/**
 * Order here is important, AuthHttpInterceptor from Auth0 must be last in the list
 *
 * If configured for Auth0, the tilled RefreshTokenInterceptor is replaced
 * with the UnauthenticatedRouteInterceptor allowing the request to either
 * pass through for authenticated calls or be routed directly to the backend
 *
 * If not configured for Auth0 both the RefreshTokenInterceptor and AuthHttpInterceptor
 * are registered however the RefreshTokenInterceptor passes the request to the backed directly
 * instead of calling the next interceptor in the chain, skipping the AuthHttpInterceptor
 * even though it is registered.
 *
 */
export const httpInterceptorProviders = [
  {
    provide: HTTP_INTERCEPTORS,
    useClass: RequestResponseInterceptor,
    multi: true,
  },
  {
    provide: HTTP_INTERCEPTORS,
    useFactory: function (brandingService: BrandingService, injector: Injector, backend: HttpBackend) {
      if (!brandingService.authConfig.useAuth0) {
        return new RefreshTokenInterceptor(injector, backend);
      }
      return new UnauthenticatedRouteInterceptor(backend);
    },
    multi: true,
    deps: [BrandingService, Injector, HttpBackend],
  },
  { provide: HTTP_INTERCEPTORS, useClass: AuthHttpInterceptor, multi: true },
];
